import { Nullable } from 'common-types';

export interface ApiKey {
  id: string;
  apiKeyRoleType: ApiKeyRoleType;
  name: string;
  description: string;
  createdBy: string;
  iss: string;
  iat: number;
  exp: number;
  orgId: string;
  apiKeyStatus: ApiKeyStatus;
  hashedKeySecret: string;
  lastUsed: Nullable<number>;
}

export interface CreateApiKeyRes {
  apiKey: ApiKey;
  keySecret: string;
}

export enum ApiKeyStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Expired = 'Expired',
}

export enum ApiKeyRoleType {
  CICDIntegration = 'CICDIntegration',
  APIIntegration = 'APIIntegration',
}

export enum ApiKeyError {
  FailedLoadApiKeys = 'Failed to load API keys, please try again later',
  FailedDeleteApiKeys = 'Failed to delete API key, please try again later',
  FailedSetApiKeyStatus = 'Failed to set API key status, please try again later',
  FailedSetApiKeyExpiration = 'Failed to set API key expiration, please try again later',
}

export interface CreateApiKeyInput {
  apiKeyRoleType: ApiKeyRoleType;
  expiresInSec: number;
  name: string;
  description: string;
}

export interface DeleteApiKeyInput {
  id: string;
}

export interface SetApiKeyStatusInput {
  id: string;
  apiKeyStatus: ApiKeyStatus;
}

export interface SetApiKeyExpirationInput {
  id: string;
  expiresInSec: number;
}
